import React from 'react';

const Pagination = ({ nPages, currentPage, setCurrentPage }) => {
    
    const MAX_VISIBLE_PAGES = 10;
    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    const nextPage = () => {
        if (currentPage !== nPages) setCurrentPage(currentPage + 1);
    };
    const prevPage = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1);
    };

    const renderPageNumbers = () => {
        if (nPages <= 0) {
            return (
                <li className="page-item disabled">
                    <span className="page-link">0</span>
                </li>
            );
        } else if (nPages <= MAX_VISIBLE_PAGES) {
            return pageNumbers.map(pgNumber => (
                <li key={pgNumber} className={`page-item ${currentPage === pgNumber ? 'active' : ''}`}>
                    <a onClick={() => setCurrentPage(pgNumber)} style={{ cursor: 'pointer' }} className='page-link'>
                        {pgNumber}
                    </a>
                </li>
            ));
        } else {
            const pageRangeStart = Math.max(currentPage - Math.floor(MAX_VISIBLE_PAGES / 2), 1);
            const pageRangeEnd = Math.min(pageRangeStart + MAX_VISIBLE_PAGES - 1, nPages);
            const pagesToDisplay = [...Array(pageRangeEnd - pageRangeStart + 1).keys()].map(page => page + pageRangeStart);

            return (
                <>
                    {pageRangeStart > 1 && (
                        <>
                            <li className="page-item">
                                <a onClick={() => setCurrentPage(1)} style={{ cursor: 'pointer' }} className='page-link'>
                                    1
                                </a>
                            </li>
                            {pageRangeStart > 2 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}
                        </>
                    )}
                    {pagesToDisplay.map(pgNumber => (
                        <li key={pgNumber} className={`page-item ${currentPage === pgNumber ? 'active' : ''}`}>
                            <a onClick={() => setCurrentPage(pgNumber)} style={{ cursor: 'pointer' }} className='page-link'>
                                {pgNumber}
                            </a>
                        </li>
                    ))}
                    {pageRangeEnd < nPages && (
                        <>
                            {pageRangeEnd < nPages - 1 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}
                            <li className="page-item">
                                <a onClick={() => setCurrentPage(nPages)} style={{ cursor: 'pointer' }} className='page-link'>
                                    {nPages}
                                </a>
                            </li>
                        </>
                    )}
                </>
            );
        }
    };    

    return (
        <nav style={{ textAlign: 'right' }}>
            <ul className="pagination">
                <li className="page-item">
                    <a className="page-link" style={{ cursor: 'pointer' }} onClick={prevPage}>
                        Previous
                    </a>
                </li>
                {renderPageNumbers()}
                <li className="page-item">
                    <a className="page-link" style={{ cursor: 'pointer' }} onClick={nextPage}>
                        Next
                    </a>
                </li>
            </ul>
        </nav>
    );
};

// Apply styles inline for the 70% white and 30% #F1C841 theme
const styles = `
    .pagination .page-link {
        background-color: #ffffff;  /* 70% white */
        border: 1px solid #F1C841; /* 30% accent with border */
        color: #F1C841;            /* Text in accent color */
        font-weight: bold;
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    .pagination .page-item.active .page-link {
        background-color: #F1C841; /* 30% accent for active page */
        color: #ffffff;            /* White text for contrast */
        border-color: #F1C841;
    }

    .pagination .page-link:hover {
        background-color: #F1C841; /* Hover effect with accent */
        color: #ffffff;            /* White text on hover */
    }

    .pagination .page-item.disabled .page-link {
        background-color: #ffffff;
        color: #ccc;
        border: 1px solid #f3d97f;
    }
`;

// Inject the styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Pagination;
